import { WindowStateActions } from './window/window.actions';
import { cloneDeep } from '../../utils/cloneDeep';
import { ROOT_EFFECTS_INIT } from '@ngrx/effects';

const sessionPreservedItems = [
  { key: 'vaButton.isFloatingButtonEnabled', value: '' },
  { key: 'vaButton.chatAppBrand', value: '' },
  { key: 'vaButton.minimizedHeaderTitle', value: '' },
  { key: 'vaButton.popOverText', value: '' },
  { key: 'settings', value: '' },
  { key: 'vaButton.buttonText', value: '' },
  { key: 'vaButton.logoImageUrl', value: '' },
  { key: 'pendingAction', value: '' },
];

const savePreservedItems = (state: any) => {
  for (const item of sessionPreservedItems) {
    const keys = (<any>item).key.split('.');
    let propValue = state;
    for (const key of keys) {
      propValue = propValue[key];
    }
    (<any>item).value = propValue;
  }
};

const applyPreservedItems = (state: any) => {
  if (state) {
    for (const item of sessionPreservedItems) {
      const keys = (<any>item).key.split('.');
      let prop = state;
      for (let i = 0; i < keys.length - 1; i++) {
        prop = prop[keys[i]];
      }
      prop[keys[keys.length - 1]] = item.value;
    }
  }
};

const onCloseClearState = (reducer) => {
  return (state, action) => {
    if (action.type === WindowStateActions.closeWindow.type) {
      savePreservedItems(state);
      state = undefined;
      const nextState = reducer(state, action);
      const clonedState = cloneDeep(nextState);
      applyPreservedItems(clonedState);
      return clonedState;
    }
    return reducer(state, action);
  };
};

export const getMetaReducers = ({ storeValueInIdb }) => [
  (reducer) => {
    return (state, action) => {
      if (action.type === ROOT_EFFECTS_INIT && storeValueInIdb) {
        const clonedState = cloneDeep(state);
        if (clonedState) {
          for (const prop in clonedState) {
            if (storeValueInIdb[prop] && Object.hasOwn(clonedState, prop)) {
              if (
                typeof clonedState[prop] === 'object' &&
                typeof storeValueInIdb[prop] === 'object' &&
                !Array.isArray(storeValueInIdb[prop])
              ) {
                clonedState[prop] = {
                  ...clonedState[prop],
                  ...storeValueInIdb[prop],
                };
              } else {
                clonedState[prop] = storeValueInIdb[prop];
              }
            }
          }
        }
        return clonedState;
      }
      return reducer(state, action);
    };
  },
  onCloseClearState,
];
